module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/font/notokr-regular.woff
// module id = wLnp
// module chunks = 0